import * as LucideIcons from "lucide-react";

export function Icon({ name, size = 24 }) {
  const LucideIcon = LucideIcons[name] || LucideIcons.Workflow; // Fallback icon
  return <LucideIcon size={size} style={{ color: "#06ff88" }} />;
}
